import classNames from 'classnames';
import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ScrollInfo } from '../../../Common';

export interface PagenationProps {
  /**
   * 全ての件数
   */
  maxNum: number;
  /**
   * 1ページあたりの表示件数
   */
  pageRows: number;
  /**
   * 現在のページ
   */
  currentPage: number;
  /**
   * 取得できている件数
   */
  existNum: number;
  /**
   * APIで取得した基準インデックス
   */
  apiUpdateIndex: number;

  /**
   * APIで取得するときのスクロール情報
   */
  scrollSize: number;

  /**
   * ページの切替えアクション
   */
  setCurrentPage: (pageNum: number) => void;

  className?: string;

  isRight?: boolean;
  /**
   * ページ再描画
   */
  search: (from: number) => void;

  /**
   * 検索ページング基準インデックスを更新
   */
  setApiUpdateIndex: (apiUpdateIndex: number) => void;
}

export class Pagenation extends Component<PagenationProps, any> {
  constructor(props: PagenationProps) {
    super(props);

    this.state = {};
  }

  prevPage() {
    // 指定されたページ番号がstartPageより小さければ、APIを呼び出して再描画する
    // apiUpdateIndexを更新
    // pagingのfromを計算する
    // 計算結果がマイナスだったらfrom は0
    const halfPageCount = Math.ceil(this.props.scrollSize / 2 / this.props.pageRows);
    const startPage = this.props.apiUpdateIndex - halfPageCount < 0 ? 0 : this.props.apiUpdateIndex - halfPageCount;
    const nextPage = this.props.currentPage - 1;

    if (nextPage < startPage) {
      // API呼んで再描画
      // -1でページ番号から配列のインデックスに変換
      const from = (nextPage - halfPageCount - 1) * this.props.pageRows;
      this.props.search(from < 0 ? 0 : from);
      this.props.setApiUpdateIndex(nextPage);
    }

    this.props.setCurrentPage(nextPage);
  }

  nextPage() {
    // 指定されたページ番号がendPageより大きければ、APIを呼び出して再描画する
    // apiUpdateIndexを更新
    // pagingのfromを計算する
    // 計算結果がMaxNumより多かったらfromはMaxNum
    const maxPage = Math.ceil(this.props.maxNum / this.props.pageRows);
    const halfPageCount = Math.ceil(this.props.scrollSize / 2 / this.props.pageRows);
    const existPages = Math.ceil(this.props.existNum / this.props.pageRows);
    const endPage =
      this.props.apiUpdateIndex + (existPages - halfPageCount - 1) > maxPage
        ? maxPage
        : this.props.apiUpdateIndex + (existPages - halfPageCount - 1);
    const nextPage = this.props.currentPage + 1;

    if (nextPage > endPage) {
      // API呼んで再描画
      // -1でページ番号から配列のインデックスに変換
      const from = (nextPage - halfPageCount - 1) * this.props.pageRows;
      this.props.search(this.props.maxNum < from ? this.props.maxNum : from);
      this.props.setApiUpdateIndex(nextPage);
    }

    this.props.setCurrentPage(nextPage);
  }

  selectPage(nextPage: number) {
    //指定されたページ番号がstartPageとendPageの間にいなければ再描画
    const maxPage = Math.ceil(this.props.maxNum / this.props.pageRows);
    const halfPageCount = Math.ceil(this.props.scrollSize / 2 / this.props.pageRows);
    const existPages = Math.ceil(this.props.existNum / this.props.pageRows);
    const startPage = this.props.apiUpdateIndex - halfPageCount < 0 ? 0 : this.props.apiUpdateIndex - halfPageCount;
    const endPage =
      this.props.apiUpdateIndex + (existPages - halfPageCount - 1) > maxPage
        ? maxPage
        : this.props.apiUpdateIndex + (existPages - halfPageCount - 1);

    if (nextPage < startPage || endPage < nextPage) {
      // API呼んで再描画
      // -1でページ番号から配列のインデックスに変換
      const from = (nextPage - halfPageCount - 1) * this.props.pageRows;

      this.props.search(from < 0 ? 0 : this.props.maxNum < from ? this.props.maxNum : from);
      this.props.setApiUpdateIndex(nextPage);
    }
    this.props.setCurrentPage(nextPage);
  }

  renderPagingButtons(): ReactNode[] {
    //maxpage
    const pages = this.props.maxNum / this.props.pageRows;

    const res: ReactNode[] = [];

    if (this.props.currentPage > 1) {
      // 「<」の描画
      res.push(
        <li key='arrow_left' className='uc-pagination__item'>
          <Link className='uc-pagination__item-link' to='#' onClick={() => this.prevPage()} data-testid='move_to_left_page'>
            <i className='material-icons'>keyboard_arrow_left</i>
          </Link>
        </li>
      );
    }

    let flag = false;
    // ページ分作成
    for (let i = 0; i < pages; i++) {
      let pageNum = i + 1;
      //最初のページ
      //最後のページ
      //対象ページが現在ページから両隣2番め以内か
      if (pageNum == 1 || pageNum >= pages || (pageNum >= this.props.currentPage - 2 && pageNum <= this.props.currentPage + 2)) {
        flag = false;

        //現在ページ
        if (pageNum == this.props.currentPage) {
          //リンクなし
          res.push(
            <li key={pageNum} className='uc-pagination__item uc-pagination__item--active' aria-current='page'>
              <span className='uc-pagination__item-link'>{pageNum}</span>
            </li>
          );
        } else {
          //リンク有り
          res.push(
            <li key={pageNum} className='uc-pagination__item'>
              <Link className='uc-pagination__item-link' to='#' onClick={() => this.selectPage(pageNum)} data-testid='move_to_select_page'>
                {pageNum}
              </Link>
            </li>
          );
        }
      } else {
        // 「...」を描画
        if (!flag) {
          flag = true;
          res.push(
            <li key={`ellipsis-${i}`} className='uc-pagination__item'>
              <span className='uc-pagination__item-ellipsis'></span>
            </li>
          );
        }
      }
    }

    if (this.props.currentPage < pages) {
      // 「>」の描画
      res.push(
        <li key='arrow_right' className='uc-pagination__item'>
          <Link
            className='uc-pagination__item-link'
            to='#'
            onClick={() => this.nextPage()}
            data-testid='move_to_right_page'
            data-testid-e2e='pagenation-move-right'>
            <i className='material-icons'>keyboard_arrow_right</i>
          </Link>
        </li>
      );
    }

    return res;
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className={classNames('uc-pagination-wrapper u-flex', this.props.isRight && "u-justify-end")}>
          <div className='uc-pagination-help u-text-m u-mr16' data-testid='searchResult' data-testid-e2e='pagenation-selectcount-result'>
            検索結果 : {(this.props.currentPage - 1) * this.props.pageRows + 1}〜
            {this.props.maxNum / this.props.pageRows < this.props.currentPage
              ? this.props.maxNum
              : this.props.currentPage * this.props.pageRows}{' '}
            / {this.props.maxNum}件
          </div>
          <ul className='uc-pagination' data-testid='pagingList'>
            {this.renderPagingButtons()}
          </ul>
        </div>
      </div>
    );
  }
}

export default Pagenation;
